export { FloatingWrapper, FloatingWrapperWithSchema } from './FloatingWrapper.js';
export type { DSFloatingWrapperT } from './react-desc-prop-types.js';
export { DSFloatingWrapperName, DSFloatingWrapperSlots, DSFloatingWrapperDataTestids } from '../../constants/index.js';
